export function loadJs(src) {
	return new Promise(function(resolve, reject) {
		const script = document.createElement('script')
		script.type = 'text/javascript';
		script.onload = resolve;
		script.onerror = reject;
		script.src = src;
		document.head.append(script);
	});
}